import type { OnlineStatusFilter, PhoneCountryCode } from '@/entities/clients-filter.entity';
import { createEvent, createStore } from 'effector';

export interface IMyFilter {
	time: string;
	onlineStatus: OnlineStatusFilter;
	removeWithoutPhone: boolean;
	excludePhoneCountries: PhoneCountryCode[];
	removeTgUsed: boolean;
	removeWithoutTgCode: boolean;
	removeWithTg2FA: boolean;
	removeTaken: boolean;
}

export const defaultMyFilter: IMyFilter = {
	time: '1d',
	onlineStatus: 'online',
	removeWithoutPhone: false,
	excludePhoneCountries: [],
	removeTgUsed: false,
	removeWithoutTgCode: false,
	removeWithTg2FA: false,
	removeTaken: false,
};

export const $setMyFilter = createEvent<IMyFilter>();
export const $updateMyFilter = createEvent<Partial<IMyFilter>>();

export const $myFilter = createStore<IMyFilter>(defaultMyFilter)
	.on($setMyFilter, (_, payload) => payload)
	.on($updateMyFilter, (state, payload) => ({ ...state, ...payload }));
